import React, { useContext, useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import About from "./InsocialOrbit/Main/About";
import Contact from "./InsocialOrbit/Main/Contact";
import CookiePolicy from "./InsocialOrbit/Main/CookiePolicy";
import Home from "./InsocialOrbit/Main/Home";
import PrivacyPolicy from "./InsocialOrbit/Main/PrivacyPolicy";
import TermsAndConditions from "./InsocialOrbit/Main/TermsAndConditions";
import UserAgreement from "./InsocialOrbit/Main/UserAgreement";

import Brand from "./InsocialOrbit/Main/Brand";
import Influencer from "./InsocialOrbit/Main/Influencer";

import Navbar from "./InsocialOrbit/Layout/Navbar";
import Sidebar from "./InsocialOrbit/Layout/Sidebar";
import Footer from "./InsocialOrbit/Main/Layout/Footer";
import Header from "./InsocialOrbit/Main/Layout/Header";
import Notification from "./InsocialOrbit/Main/Notification";

import Login from "./InsocialOrbit/Auth/Login";
import LoginWithEmail from "./InsocialOrbit/Auth/LoginWithEmail";
import LoginWithPhone from "./InsocialOrbit/Auth/LoginWithPhone";
import LoginWithPhoneOrEmail from "./InsocialOrbit/Auth/LoginWithPhoneOrEmail";
import OtpVerification from "./InsocialOrbit/Auth/OtpVerification";
import SignUp from "./InsocialOrbit/Auth/SignUp";
import SignUpWith from "./InsocialOrbit/Auth/SignUpWith";
import SignUpWithEmail from "./InsocialOrbit/Auth/SignUpWithEmail";
import SignUpWithOtp from "./InsocialOrbit/Auth/SignUpWithOtp";
// import SignupWithPhoneOtp from "./InsocialOrbit/Auth/SignUpWithPhoneOtp";

import { RoutesLink } from "./InsocialOrbit/Common/RoutesLink";
import CopyRights from "./InsocialOrbit/Main/CopyRIght";

import BrandHome from "./InsocialOrbit/Brand/BrandHome";
import Campaign from "./InsocialOrbit/Brand/Campaign/Campaign";
import CollabReqTable from "./InsocialOrbit/Brand/CollabReqTable";
import Insights from "./InsocialOrbit/Brand/Insights/Insights";
import Message from "./InsocialOrbit/Brand/Message/Message";

import SignUpWithPhone from "./InsocialOrbit/Auth/SignUpWithPhone";
import SignUpWithPhoneOtp from "./InsocialOrbit/Auth/SignUpWithPhoneOtp";
import CampaignCreate from "./InsocialOrbit/Brand/Campaign/CampaignCreate";
import CampaignDetails from "./InsocialOrbit/Brand/Campaign/CampaignDetails";
import insightcard from "./InsocialOrbit/Brand/Campaign/insightcard";
import InstagramInsights from "./InsocialOrbit/Brand/Insights/Instagram";
import YoutubeInsights from "./InsocialOrbit/Brand/Insights/Youtube";
import MyProfile from "./InsocialOrbit/Common/MyProfile";
import campaignInfluencer from "./InsocialOrbit/Influencer/campaignInfluencer";
import InfluencerDetail from "./InsocialOrbit/Influencer/InfluencerDetail";
import influencerHome from "./InsocialOrbit/Influencer/influencerHome";
import InfluencerProfile from "./InsocialOrbit/Influencer/InfluencerProfile";
import PaymentDashboard from "./InsocialOrbit/Influencer/PaymentDashboard";
import PaymentMethod from "./InsocialOrbit/Influencer/PaymentMethod";
import MyWallet from "./InsocialOrbit/Influencer/MyWallet";
import InstaAcoordian from "./InsocialOrbit/Main/InstaAcoordian";
import ScrollToTop from "./ScrollToTop";
import { GlobalContext } from "./utils/GlobalContext";

import AdminDashboard from "./InsocialOrbit/Admin_Dashboard/AdminDashboard";
import BrandDetailsadminDashboard from "./InsocialOrbit/Admin_Dashboard/BrandDetailsadminDashboard";
import ContactsDashboard from "./InsocialOrbit/Admin_Dashboard/ContactsDashboard";
import DashboardQueries from "./InsocialOrbit/Admin_Dashboard/DashboardQueries";
import ContractforCollaboration from "./InsocialOrbit/Brand/Campaign/ContractforCollaboration";
import DashboarInfluencer from "./InsocialOrbit/Influencer/DashboardInfluencer";
// import UserContact from "./InsocialOrbit/Main/UserContact";
import { BrandApproval } from "./InsocialOrbit/Admin/BrandApproval";
import { InfluencesApproval } from "./InsocialOrbit/Admin/InfluencesApproval";
import { SetupBrandProfile } from "./InsocialOrbit/Common/SetupProfile/brand";
import { InfluencerDetails } from "./InsocialOrbit/Influencer/influencerDetails";
// import InfluencerCompareModal from "./InsocialOrbit/Influencer/influencerDetails/InfluencerCompareModal";

import SubScriPtionMethod from "./InsocialOrbit/Brand/SubScriPtionMethod";
import MemberShipUpgrade from "./InsocialOrbit/Brand/MemberShipUpgrade";
import ViewBrandProfile from "./InsocialOrbit/Common/ViewBrandProfile";
import InsightsHome from "./InsocialOrbit/Brand/Insights/insightsHome";
import insightsDeliverables from "./InsocialOrbit/Brand/Insights/insightsDeliverables";

import AuthSubscription from "./InsocialOrbit/Auth/AuthSubscription";
import CancellationPolicy from "./InsocialOrbit/Main/CancellationPolicy";

// profile setting pages
import PaymentMethods from "./InsocialOrbit/ProfileSetting/PaymentMethods";
import TransactionHistory from "./InsocialOrbit/ProfileSetting/TransactionHistory";
import SubscriptionPlans from "./InsocialOrbit/ProfileSetting/SubscriptionPlans";
import SettingsPage from "./InsocialOrbit/ProfileSetting/SettingsPage";
import Chatbot from "./InsocialOrbit/Common/Chatbot";

const componentsMap = {
  Home,
  About,
  Brand,
  Influencer,
  Login,
  LoginWithPhoneOrEmail,
  LoginWithPhone,
  LoginWithEmail,
  OtpVerification,
  SignUp,
  SignUpWith,
  Contact,
  PrivacyPolicy,
  Notification,
  TermsAndConditions,
  CopyRights,
  UserAgreement,
  CookiePolicy,
  BrandHome,
  Campaign,
  Insights,
  YoutubeInsights,
  InstagramInsights,
  Message,
  InfluencerDetail,
  SignUpWithOtp,
  InfluencerDetails,
  InstaAcoordian,
  PaymentDashboard,
  SignUpWithEmail,
  PaymentMethod,
  MyProfile,
  SettingsPage,
  CampaignDetails,
  InfluencerProfile,
  CampaignCreate,
  influencerHome,
  campaignInfluencer,
  SignUpWithPhone,
  SignUpWithPhoneOtp,
  insightcard,
  DashboardQueries,
  BrandDetailsadminDashboard,
  AdminDashboard,
  ContactsDashboard,
  ContractforCollaboration,
  DashboarInfluencer,
  CollabReqTable,
  InfluencesApproval,
  BrandApproval,
  SubScriPtionMethod,
  MemberShipUpgrade,
  // InfluencerCompareModal,
  // UserContact
  ViewBrandProfile,
  InsightsHome,
  insightsDeliverables,
  AuthSubscription,
  CancellationPolicy,

  PaymentMethods,
  TransactionHistory,
  SubscriptionPlans,
  Chatbot,
  MyWallet,
};

// Private Layout (Sidebar and Navbar)
const PrivateLayout = ({ children }) => {
  const { userData } = useContext(GlobalContext);
  const location = useLocation();

  // Define routes where the sidebar should be hidden
  const hideSidebarRoutes = ["/my-wallet"];

  // Check if the current path is in the hideSidebarRoutes array
  const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname);
  return (
    <div className="row g-0">
      <div className="MainScreen">
        {/* <Sidebar /> */}
        {!shouldHideSidebar && <Sidebar />}
        <div className="w-100">
          <Navbar />
          <div
            className={`ChieldComponent ${
              userData?.role === "admin" || location.pathname === "/myprofile"
                ? "admin-bg"
                : ""
            }`}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

// Public Layout (Header and Footer)
const PublicLayout = ({ children }) => {
  const location = useLocation();

  // Routes where Header/Footer should be hidden
  const hideLayoutRoutes = [
    "/admininsociaalorbit",
    "/membership-upgrade",
    "/subscription",
  ];

  const shouldHideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideLayout && <Header />}
      <main>{children}</main>
      {!shouldHideLayout && <Footer />}
    </>
  );
};

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userData } = useContext(GlobalContext);
  const [isSetupProfileModal, setIsSetupProfileModal] = useState(false);

  useEffect(() => {
    const setupProfileModalClosed =
      localStorage.getItem("setupProfileModalClosed") || "false";
    const shouldOpen =
      location.pathname === "/influencer-home" ||
      location.pathname === "/brand-home";
    if (
      userData?.user_id &&
      !userData?.isprofilecompleted &&
      setupProfileModalClosed === "false" &&
      shouldOpen
    ) {
      setIsSetupProfileModal(true);
    }
  }, [userData, location.pathname]);

  return (
    <>
      <ScrollToTop />
      {isSetupProfileModal ? (
        <SetupBrandProfile
          open={isSetupProfileModal}
          onClose={(mode) => {
            if (mode === "manual") {
              localStorage.setItem("setupProfileModalClosed", true);
            }
            setIsSetupProfileModal(false);
            if (mode === "save") {
              navigate("/myprofile");
            }
          }}
        />
      ) : (
        <></>
      )}
      <Routes>
        {RoutesLink.map((route) => {
          const Component = componentsMap[route.component];

          // if (route.isPrivate && !isLogdin) {
          //   return (
          //     <Route
          //       key={route.path}
          //       path={route.path}
          //       element={<Navigate to="/login" />}
          //     />
          //   );
          // }

          // if (!route.isPrivate && route.path === "/login" && isLogdin) {
          //   const role = localStorage.getItem("userType");

          //   return (
          //     <Route
          //       key={route.path}
          //       path={route.path}
          //       element={
          //         <Navigate
          //           to={
          //             role === "influencer" ? "/influencer-home" : "/brand-home"
          //           }
          //         />
          //       }
          //     />
          //   );
          // }

          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                route.isPrivate ? (
                  <PrivateLayout>
                    <Component />
                  </PrivateLayout>
                ) : (
                  <PublicLayout>
                    <Component />
                  </PublicLayout>
                )
              }
            />
          );
        })}

        {/* Catch-all route for private paths without authentication */}
        <Route path="/private/*" element={<Navigate to="/login" />} />
      </Routes>
    </>
  );
}

export default App;
